import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=0890d986&scoped=true&"
var script = {}
import style0 from "./Contacts.vue?vue&type=style&index=0&id=0890d986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890d986",
  null
  
)

export default component.exports